/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryBreadcrumbResponse } from './RevisdomAPIViewModelsEntryBreadcrumbResponse';
import {
    RevisdomAPIViewModelsEntryBreadcrumbResponseFromJSON,
    RevisdomAPIViewModelsEntryBreadcrumbResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryBreadcrumbResponseToJSON,
    RevisdomAPIViewModelsEntryBreadcrumbResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryBreadcrumbResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryBreadcrumbListResponse
 */
export interface RevisdomAPIViewModelsEntryBreadcrumbListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryBreadcrumbResponse>}
     * @memberof RevisdomAPIViewModelsEntryBreadcrumbListResponse
     */
    items?: Array<RevisdomAPIViewModelsEntryBreadcrumbResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryBreadcrumbListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryBreadcrumbListResponse(value: object): value is RevisdomAPIViewModelsEntryBreadcrumbListResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryBreadcrumbListResponseFromJSON(json: any): RevisdomAPIViewModelsEntryBreadcrumbListResponse {
    return RevisdomAPIViewModelsEntryBreadcrumbListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryBreadcrumbListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryBreadcrumbListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RevisdomAPIViewModelsEntryBreadcrumbResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryBreadcrumbListResponseToJSON(json: any): RevisdomAPIViewModelsEntryBreadcrumbListResponse {
    return RevisdomAPIViewModelsEntryBreadcrumbListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryBreadcrumbListResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryBreadcrumbListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RevisdomAPIViewModelsEntryBreadcrumbResponseToJSON)),
    };
}

